var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoFuncaoComparar01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 36 36",
    style: {
      enableBackground: "new 0 0 36 36"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2203",
    transform: "translate(0 1.387)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1210",
    d: "M13,18.8c-0.4,0-0.7,0.3-0.7,0.7c0,0,0,0,0,0l0,4.9H2.5v-21h14.4V6c0.3-0.2,0.7-0.3,1-0.3h1V2.4 c0-0.4-0.3-0.7-0.7-0.7H1.2c-0.4,0-0.7,0.3-0.7,0.7v23.1c0,0.4,0.3,0.7,0.7,0.7h0H14c0.2,0,0.4-0.1,0.5-0.2l1.6-1.8v-5.3L13,18.8 L13,18.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1211",
    d: "M11,16.7l4.2-3.5c0.2-0.1,0.2-0.4,0.1-0.5c0,0,0,0,0,0c-0.4-0.4-4.4-3.4-4.4-3.4s-0.5-0.5-0.5,0.2v1.8 H4.3c0,0-0.3,0-0.3,0.3v2.8c0,0.5,0.3,0.4,0.3,0.4h6.2v2C10.5,17.3,11,16.7,11,16.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1212",
    d: "M34.5,6.7H17.4c-0.4,0-0.7,0.3-0.7,0.7v23.1c0,0.4,0.3,0.7,0.7,0.7h12.8c0.2,0,0.4-0.1,0.5-0.2L35,26 c0.1-0.1,0.2-0.3,0.2-0.4V7.4C35.2,7,34.9,6.7,34.5,6.7z M33.1,23.8h-3.9l0,0c-0.2,0-0.4,0.1-0.5,0.2c-0.1,0.1-0.2,0.3-0.2,0.5 l0,4.9h-9.8v-21h14.4L33.1,23.8L33.1,23.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1213",
    d: "M24.8,22.7c0,0,0.5,0.5,0.5-0.2v-1.8h6.1c0,0,0.3,0,0.3-0.3v-2.8c0-0.5-0.3-0.4-0.3-0.4h-6.2v-2 c0-0.6-0.5,0-0.5,0l-4.2,3.5c-0.2,0.1-0.2,0.4-0.1,0.6c0,0,0,0,0,0C20.8,19.7,24.8,22.7,24.8,22.7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoFuncaoComparar01);
export default __webpack_public_path__ + "static/media/ico-funcao-comparar-01.c5a3d3eb2edf41fada3e6bf20a1e6167.svg";
export { ForwardRef as ReactComponent };